import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrip } from '../store/actions';
import { StoreState } from '../types/store.type';

/**
 * Custom hook to call Trip API and update the Redux store with the response
 * @param useExistingStore - use the current store (if exist), instead of hitting the API
 * @param cleanCache - flag to force a /invalidate-cache call
 * @param cleanStore - flag to force a clean local store and wait for request
 */

export function useTripStoreUpdater(useExistingStore = false, cleanCache = false, cleanStore = false): void {
    const dispatch = useDispatch();
    const trip = useSelector((store: StoreState) => store.trip);
    const { shouldCleanCache } = trip;

    useEffect(() => {
        if (useExistingStore && trip.reservation) {
            return;
        }

        if (cleanStore) {
            dispatch(fetchTrip(cleanCache, true));
            return;
        }

        if (shouldCleanCache || cleanCache) {
            dispatch(fetchTrip(true));
            return;
        }

        dispatch(fetchTrip(false));
    }, []);
}
